<ng-template #contentHeaderTemplate>
  <div class="row">
    <div class="col-12 d-flex justify-content-end ">
      <button class="btn btn-primary" (click)="save()">
        {{ 'misc.save_btn' | translate }}
      </button>
    </div>
  </div>
</ng-template>

@if (patient && patient.id) {
  <app-tab-switcher
    [config]="[
    {link: '/patients/' + this.patient!.id, translationKey: 'authenticated.patients.edit.tabs.details', exact: true},
    {link: '/patients/' + this.patient!.id + '/documents', translationKey: 'authenticated.patients.edit.tabs.documents', exact: true},
    {link: '/patients/' + this.patient!.id + '/emails', translationKey: 'authenticated.patients.edit.tabs.emails', exact: false},
    {link: '/patients/' + this.patient!.id + '/history', translationKey: 'authenticated.patients.edit.tabs.history', exact: false},
  ]"
  ></app-tab-switcher>

  <form [formGroup]="form" (submit)="save()" class="row g-3">

    <div class="col-12 col-md-9 order-md-1">

      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.patients.edit.details_header' | translate }}
        </div>
        <div class="card-body">
          <div class="row">

            <div class="col-12 col-lg-6 py-1">
              <app-multi-select-enum
                [enum]="PatientGenderEnum"
                translateKey="patientGenderEnum"
                [formControl]="form.controls.gender"
                label="{{'authenticated.patients.edit.form.gender.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.gender.validation_messages.required' | translate)}"
                [multi]="false"
              ></app-multi-select-enum>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.last_name"
                label="{{'authenticated.patients.edit.form.last_name.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.last_name.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.first_name"
                label="{{'authenticated.patients.edit.form.first_name.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.first_name.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-date-time
                [formControl]="form.controls.birthdate"
                label="{{'authenticated.patients.edit.form.birthdate.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.birthdate.validation_messages.required' | translate)}"
              ></app-date-time>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.email"
                label="{{'authenticated.patients.edit.form.email.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.email.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.phone_number"
                label="{{'authenticated.patients.edit.form.phone_number.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.phone_number.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.requests_callback"
                type="checkbox"
                [centerCheckbox]="true"
                label="{{'authenticated.patients.edit.form.requests_callback.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.requests_callback.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

          </div>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.patients.edit.request_header' | translate }}
        </div>
        <div class="card-body">
          <div class="row">

            <div class="col-12 py-1">
              <app-form-group
                [formControl]="form.controls.request_description"
                type="textarea"
                label="{{'authenticated.patients.edit.form.request_description.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.request_description.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-multi-select-with-service-list
                [service]="diagnosisService"
                [filters]="{'is_category': 'false'}"
                [searchOnField]="'title'"
                [formControl]="form.controls.diagnoses"
                label="{{'authenticated.patients.edit.form.diagnosis.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.diagnosis.validation_messages.required' | translate)}"
                [sort]="'-created_at'"
                [selectionMode]="'multiple_ids'"
              ></app-multi-select-with-service-list>
            </div>

            <div class="col-12 col-lg-6 py-1">
              @if (patient?.diagnosis) {
                <app-read-only-static
                  [value]="patient?.diagnosis ?? ''"
                  label="{{'authenticated.patients.edit.form.diagnosis.label' | translate }}"
                  [errorMessages]="{required: ('authenticated.patients.edit.form.diagnosis.validation_messages.required' | translate)}"
                ></app-read-only-static>
              }
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.previous_therapy"
                label="{{'authenticated.patients.edit.form.previous_therapy.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.previous_therapy.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-date-time
                [formControl]="form.controls.date_of_last_mri_or_ct"
                label="{{'authenticated.patients.edit.form.date_of_last_mri_or_ct.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.date_of_last_mri_or_ct.validation_messages.required' | translate)}"
              ></app-date-time>
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-multi-select-enum
                [enum]="PatientOriginEnum"
                [formControl]="form.controls.origin"
                translateKey="patientOriginEnum"
                [multi]="false"
                label="{{'authenticated.patients.edit.form.origin.label' | translate }}"
              ></app-multi-select-enum>
            </div>

            <div class="col-12 col-lg-6 py-1">
              @if (form.controls.origin.value === PatientOriginEnum.OTHER) {
                <app-form-group
                  [formControl]="form.controls.other_origin"
                  label="{{'authenticated.patients.edit.form.origin.label' | translate }}"
                ></app-form-group>
              }
            </div>

            <div class="col-12 col-lg-6 py-1">
              <app-form-group
                [formControl]="form.controls.requests_access"
                type="checkbox"
                [centerCheckbox]="true"
                label="{{'authenticated.patients.edit.form.requests_access.label' | translate }}"
                [errorMessages]="{required: ('authenticated.patients.edit.form.requests_access.validation_messages.required' | translate)}"
              ></app-form-group>
            </div>

          </div>
        </div>
      </div>

      <app-authenticated-patients-edit-inquiries
        [patient]="patient"
      ></app-authenticated-patients-edit-inquiries>

    </div>

    <div class="col-12 col-md-3 order-md-2">
      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.patients.edit.settings_card.header' | translate }}
        </div>
        <div class="card-body">

          <div class="pb-1">
            <app-multi-select-enum
              name="state"
              [formControl]="form.controls.state"
              label="{{ 'authenticated.patients.edit.form.state.label' | translate }}"
              [multi]="false"
              placeholder="{{ 'authenticated.patients.edit.form.state.label' | translate }}"
              [enum]="PatientStateEnum"
              translateKey="patientStateEnum"
              [sortByDisplayValue]="false"
            ></app-multi-select-enum>
          </div>

          <div class="pt-1">
            <app-multi-select-enum
              name="state"
              [formControl]="form.controls.language"
              label="{{ 'authenticated.patients.edit.form.language.label' | translate }}"
              [multi]="false"
              placeholder="{{ 'authenticated.patients.edit.form.language.label' | translate }}"
              [enum]="PatientLanguageEnum"
              translateKey="patientLanguageEnum"
              [sortByDisplayValue]="false"
            ></app-multi-select-enum>
          </div>

          <div class="pt-1">
            <app-read-only-static
              [value]="patient?.source ? ('enums.patientSourceEnum.' + patient?.source | translate) : ''"
              label="{{ 'authenticated.patients.edit.form.source.label' | translate }}"
            ></app-read-only-static>
          </div>

        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.patients.edit.emails_card.header' | translate }}
        </div>
        <div class="card-body d-grid gap-4">
          <button type="button" class="btn btn-secondary w-100" (click)="sendEmail(EmailTypeEnum.PATIENT_ACCEPTANCE)">
            {{ 'enums.emailTypeEnum.patient_acceptance' | translate }}
          </button>

          <button type="button" class="btn btn-secondary w-100"
                  (click)="sendEmail(EmailTypeEnum.PATIENT_ACCEPTANCE_WITHOUT_LOGIN)">
            {{ 'enums.emailTypeEnum.patient_acceptance_without_login' | translate }}
          </button>

          <button type="button" class="btn btn-secondary w-100" (click)="sendEmail(EmailTypeEnum.PATIENT_REJECTION)">
            {{ 'enums.emailTypeEnum.patient_rejection' | translate }}
          </button>
        </div>
      </div>

      <div class="card mb-3">
        <div class="card-header">
          {{ 'authenticated.patients.edit.assignments_card.header' | translate }}
        </div>
        <div class="card-body">

          @if (addableBackofficeUsers) {
            <div class="pb-1" [appDropdownItemColors]="backOfficeUserColors">
              <app-multi-select-with-service-list
                [service]="addableBackOfficeUserService"
                [searchOnField]="'name'"
                [formControl]="form.controls.backoffice_user_id"
                label="{{'authenticated.patients.edit.form.backoffice_user.label' | translate }}"
                [sort]="'-created_at'"
                [selectionMode]="'single_id'"
              ></app-multi-select-with-service-list>
            </div>
          }

          <div class="pt-1">
            <app-multi-select-with-service-list
              [service]="addableDoctorService"
              [searchOnField]="'name'"
              [formControl]="form.controls.doctor_ids"
              label="{{'authenticated.patients.edit.form.doctors.label' | translate }}"
              [sort]="'-created_at'"
              [selectionMode]="'multiple_ids'"
            ></app-multi-select-with-service-list>
          </div>

        </div>
      </div>
    </div>
  </form>
}

@if (patient && emailType) {
  <ng-template #emailBuilderModal>
    <app-email-send
      [type]="emailType"
      [recipient]="patient"
      (closeEvent)="onCloseEmailModal()"
    ></app-email-send>
  </ng-template>
}
